import Cookies from "js-cookie";
import { getExpirationDate, isExpired } from "./checkExpiredToken";

const userAuthenticationConfig = (jsonld = true, multipart = false) => {
  let type = jsonld ? "application/json+ld" : "application/json";
  let contentType = multipart ? "multipart/form-data" : type;

  if (Cookies.get("token") !== "") {
    const expToken = isExpired(getExpirationDate(Cookies.get("token")));

    if (expToken) {
      Cookies.remove("token");

      const path = window.location.pathname;
      const languages = path.match(/^\/(en|ua)\//);
      const locale = languages ? `/${languages[1]}` : "";

      window.location.href = `${locale}/login`;
    }

    return {
      headers: {
        "Content-Type": contentType,
        "Authorization": "Bearer " + Cookies.get("token"),
        "Accept": type
      }
    };
  }
  return {
    headers: {
      "Content-Type":contentType
    }
  };
};

export default userAuthenticationConfig;
